// External resources
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

// Internal resources
import { ErrorBoundary } from 'apps/web_forms/bugsnagClient';
import Form from 'apps/web_forms/components/Form';
import Forms from 'apps/web_forms/components/Forms';
import DispatchesDetails from 'apps/web_forms/components/DispatchesDetails';
import Dispatches from 'apps/web_forms/components/Dispatches';
import DraftsPage from 'apps/web_forms/components/DraftsPage';
import AppRootComponents from 'apps/web_forms/components/AppRootComponents';
import SubmissionSuccessComponents from 'apps/web_forms/components/SubmissionSuccessComponents';
import {
  NotificationBarContext,
  useNotificationBar,
} from 'apps/web_forms/contexts/NotificationBarContext';
import store from 'apps/web_forms/reduxStore';
import { APP_BASE_NAME, APP_ROUTES } from 'apps/web_forms/utils/constants';

// Assets
import 'apps/web_forms/App.scss';
import ErrorPage from 'apps/web_forms/components/commons/ErrorPage';
import FormWrapper from 'apps/web_forms/components/FormWrapper';
import FormOld from 'apps/web_forms/components/Form/FormOld';

const queryClient = new QueryClient();

// NOTE: When editing, check FormMock.js as well
// TODO: refactor so this is not necessary, mostly
function App() {
  const notificationBarContextValue = useNotificationBar();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Router basename={APP_BASE_NAME}>
          <div id='react-app-container' className='react-app-class-container'>
            <NotificationBarContext.Provider
              value={notificationBarContextValue}
            >
              <main>
                <AppRootComponents />
                <ErrorBoundary FallbackComponent={ErrorPage}>
                  <Switch>
                    <Route path={APP_ROUTES.submissionPage} component={FormWrapper} />
                    <Route
                      path={APP_ROUTES.submissionSuccessPage}
                      component={SubmissionSuccessComponents}
                    />
                    <Route path={APP_ROUTES.formPage} component={FormWrapper} />
                    <Route
                      exact
                      path={APP_ROUTES.unauthenticatedFormPage}
                      component={FormWrapper}
                    />
                    <Route
                      path={[
                        APP_ROUTES.errorPage,
                        APP_ROUTES.sharedFormErrorPage,
                      ]}
                      component={ErrorPage}
                    />
                    <Route
                      path={APP_ROUTES.dispatchesDetails}
                      component={DispatchesDetails}
                    />
                    <Route
                      path={APP_ROUTES.dispatches}
                      component={Dispatches}
                    />
                    <Route
                      path={APP_ROUTES.draftsPage}
                      component={DraftsPage}
                    />
                    <Route path={APP_ROUTES.mainPage} component={Forms} />
                  </Switch>
                </ErrorBoundary>
              </main>
            </NotificationBarContext.Provider>
          </div>
        </Router>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
